import React from 'react'
import { targetEnv } from '@fs/zion-config'
import zionDebug from '@fs/zion-debug'
import { useFeatureFlag } from '@fs/zion-flags'
import { NotFound, Route, AuthRoute } from '@fs/zion-router'
import PropTypes from 'prop-types'

const debug = zionDebug('apac:SiteRoute')

const IS_PROD = targetEnv === 'prod'

/**
 * A wrapper for the Route component that adds some additional functionality
 * @param {object} props
 * @param {string} props.featureFlag A SplitIO feature flag to enable the route
 * @param {boolean} props.notProdReady Disables the route if used in production
 * @param {boolean} props.disabled Disables the route
 * @param {string} props.path The path of the route
 * @param {React.ComponentType} props.component The component to render
 * @param {React.ReactNode} props.render Render function
 * @param {boolean} props.authRoute Whether the route is an auth route
 */
export default function SiteRoute({ disabled, notProdReady, path, featureFlag, authRoute, ...props }) {
  const { isOn } = useFeatureFlag(featureFlag) || {}
  debug('config:', { path, disabled, notProdReady, isProd: IS_PROD, targetEnv, featureFlag, isOn })
  if ((!isOn && featureFlag) || (IS_PROD && notProdReady) || disabled) return <NotFound />
  const RouteComponent = authRoute ? AuthRoute : Route
  return <RouteComponent {...props} />
}

SiteRoute.propTypes = {
  featureFlag: PropTypes.string,
  notProdReady: PropTypes.bool,
  disabled: PropTypes.bool,
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType,
  render: PropTypes.func,
  authRoute: PropTypes.bool,
}
